import { ThemedFunctor } from '@doveit/lego';
import React from 'react';
import { TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC } from '../constants';

export const SCRIPT_TAG_ID = 'trustbox-mini';

export interface TrustBoxMiniProps {
  theme?: 'light' | 'dark',
  fullWidth?: boolean,
  clickable?: boolean,
  addCss?: ThemedFunctor,
}

/**
 * @deprecated Use `TrustpilotWidget` with type TRUSTBOX_MINI
 */
export const TrustBoxMini: React.FC<TrustBoxMiniProps> = ({
  theme = 'light',
  fullWidth = true,
  clickable = true,
  addCss,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    // load script tag once that automatically swaps our content with iframe
    if (window && !window.document.getElementById(SCRIPT_TAG_ID)) {
      const script = window.document.createElement('script');
      script.id = SCRIPT_TAG_ID;
      script.src = TRUSTPILOT_WIDGET_SCRIPT_TAG_SRC;
      window.document.head.appendChild(script);
    } else if (window.Trustpilot && ref.current) {
      // if script has been loaded before: call their API manually to redraw box
      window.Trustpilot.loadFromElement(ref.current);
    }
  });

  return (
    <div
      css={addCss}
      style={clickable ? {} : { pointerEvents: 'none', userSelect: 'none' }}
      ref={ref}
      className="trustpilot-widget"
      data-locale="it-IT"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="5cacae5d7b08650001e13ded"
      data-style-height="150px"
      data-style-width={fullWidth ? '100%' : '240px'}
      data-theme={theme}
    >
      <a
        href="https://it.trustpilot.com/review/dove.it"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustBoxMini;
